import _ from 'lodash';
import { Component, DestroyRef, ElementRef, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { skip, takeUntil } from 'rxjs/operators';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastService } from 'app/toast/services/toast.service';
import { DomSanitizer } from '@angular/platform-browser';
import { peerToPeerReport, selectP2PCampaign } from '../../features/p2p.actions';
import { selectFundraiserReport, selectSelectedP2PCampaign} from '../../features/p2p.selectors';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { ModalP2pAddFundrasingService } from 'app/manage-p2p/services/modal-p2p-add-fundrasing/modal-p2p-add-fundrasing.service';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ModalP2pDetailService } from 'app/manage-p2p/services/modal-p2p-detail/modal-p2p-detail.service';
import { P2pItemsFilterPopoverComponent } from '../p2p-items-filter-popover/p2p-items-filter-popover.component';
import { P2pDetailsPopoverComponent } from '../p2p-details-popover/p2p-details-popover.component';
import { PeerToPeerDetailsCardComponent } from '../peer-to-peer-details-card/peer-to-peer-details-card.component';
import { PeerToPeerTeamCardComponent } from '../peer-to-peer-team-card/peer-to-peer-team-card.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { NgxCurrencyDirective } from 'ngx-currency';
import { DatePipe,CurrencyPipe, CommonModule } from '@angular/common';
import { P2pDetailModalComponent } from 'app/manage-p2p/modals/p2p-detail-modal/p2p-detail-modal.component';
import { ModalP2pDowloadQRCardsService } from 'app/manage-p2p/services/modal-p2p-dowload-qr-cards/modal-p2p-dowload-qr-cards.service';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalP2pAddBulkMilestonesService } from 'app/manage-p2p/services/modal-p2p-add-bulk-milestones/modal-p2p-add-bulk-milestones.service';
import { ModalFullfillBulkPledgesService } from 'app/manage-p2p/services/modal-fulfill-bulk-donor-pledges/modal-fulfill-bulk-donor-pledges.service';
import { P2pFundraisersReportTabComponent } from '../p2p-fundraisers-report-tab/p2p-fundraisers-report-tab.component';
import { P2pDonationsReportTabComponent } from '../p2p-donations-report-tab/p2p-donations-report-tab.component';
import { P2pPledgesReportTabComponent } from '../p2p-pledges-report-tab/p2p-pledges-report-tab.component';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { Subject } from 'rxjs';


@Component({
  standalone: true,
  selector: 'app-peer-to-peer-details-list',
  templateUrl: './peer-to-peer-details-list.component.html',
  styleUrls: ['./peer-to-peer-details-list.component.scss'],
  imports:[P2pItemsFilterPopoverComponent,P2pDetailsPopoverComponent,PeerToPeerDetailsCardComponent,
    PeerToPeerTeamCardComponent,FormsModule,MdbTabsModule,CommonModule,ReactiveFormsModule,NgxCurrencyDirective,
    DatePipe,CurrencyPipe, P2pDetailModalComponent, P2pFundraisersReportTabComponent, P2pDonationsReportTabComponent,
    P2pPledgesReportTabComponent]
})

export class PeerToPeerDetailsListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  
  @Input() p2pId: string;
  public isDownloadHovered = false
  public isModalOpen = false;

  public fundraiserReport$: any = this.store.pipe(
    select(selectFundraiserReport)
  );

  public p2pCampaign$: any = this.store.pipe(
    select(selectSelectedP2PCampaign)
  );
  
  public orgId = '';
  public campaignDetail = null;

  public data = null;

  public campaignImage = '';
  public campaignName = '';
  public campaingNameIfEmpty = '';
  public creationUnix = null;
  public userCount = 0;

  public leaderboardUrl = '';
  public leaderboardIframeUrl = '';

  public progressBarHtml = null;
  public raised = 0;
  public goal = 0;

  public itemSearch: UntypedFormControl = new UntypedFormControl('', []);

  public currentTab = 'champions'
  public teams = [];
  public teamEnabled = false;
  public pledgePerEvent: boolean = false;

  public scheduleReminderClassList = {
    disabled: false
  }
  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  constructor(
    public element: ElementRef,
    public store: Store,
    public sharedService: SharedService,
    public route: ActivatedRoute,
    public router: Router,
    public peerToPeerManageService: PeerToPeerManageService,
    private modalP2pAddFundrasingService: ModalP2pAddFundrasingService,
    private clipboard: Clipboard,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private modalP2pDetailService: ModalP2pDetailService,
    public modalP2pDowloadQRCardsService: ModalP2pDowloadQRCardsService,
    private modalService: MdbModalService,
    public modalP2pAddBulkMilestonesService: ModalP2pAddBulkMilestonesService,
    private modalP2pFulfillBulkPledgesService: ModalFullfillBulkPledgesService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  ) { }

  ngOnInit(): void {
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ future }) => {
      switch(future.fragment) {
        case null:
        case "":
          this.setActiveTab("champions");
          break;
        default:
          const activeTab = future.fragment.slice(0, -3);
          this.setActiveTab(activeTab); 
      }
    });

    this.peerToPeerManageService.category = 'All'
    this.peerToPeerManageService.filterButtonText = 'All'

    this.store.dispatch({
      type: selectP2PCampaign.type,
      payload: this.p2pId
    });

    this.p2pCampaign$.pipe(
      skip(1), // Skip first emission
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((campaign)=> {
      this.campaignDetail = campaign;
      const { campaignTypeData } = this.campaignDetail;
      const imageUrl = this.campaignDetail?.imageUrl || '';
      
      this.campaignImage = imageUrl ? imageUrl : "/images/org_logo_default_v2.svg";
      this.campaingNameIfEmpty = this.campaignDetail.name;
      this.leaderboardUrl = `${window.location.protocol}//${window.location.hostname}/handle/${window['localOrgData'].user.handle}/campaign/${this.campaignDetail.intid}/leaderboard`;
      this.leaderboardIframeUrl = this.leaderboardUrl + "?iframe=true";

      this.creationUnix = this.campaignDetail.startDate * 1000;
      this.goal = campaignTypeData.goal;
      
      this.teams = campaignTypeData.teams || [];
      this.teamEnabled = campaignTypeData.teamEnabled;
      this.pledgePerEvent = campaignTypeData.pledgePerEvent;

      this.progressBarHtml = this.getProgressBarHtml();

      const { fragment } = this.route.snapshot
      switch(fragment) {
        case null:
        case "":
          this.setActiveTab("champions");
          break;
        default:
          const activeTab = this.route.snapshot.fragment.slice(0, -3);
          this.setActiveTab(activeTab); 
      }
    });

    this.store.dispatch({
      type: peerToPeerReport.type,
      payload: this.p2pId
    });
    
    this.fundraiserReport$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((donorReport)=> {
      this.data = donorReport;
      this.raised = this.getRaised(this.data);

      this.peerToPeerManageService.p2pReport = donorReport;
      this.peerToPeerManageService.filterP2pItems();

      this.campaignName = this.data[0]?.campaignData.name;
      this.userCount = this.data.length;
    })

    this.authService.getOrgUser().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((orgUser) => {
      this.orgId = orgUser.id
    })

    this.itemSearch.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(search => {
      this.peerToPeerManageService.searchQuery = search
      this.peerToPeerManageService.filterP2pItems()
    })

    window["$"](`[data-toggle="tooltip"]`).tooltip()
  }

  ngAfterViewInit(): void {
    const self = this;

    $('a[role="tab"]').off('shown.bs.tab');
    $('a[role="tab"]').on('shown.bs.tab', ({ target }) => {
      const tab = target.id.slice(0, -6);
      this.setActiveTab(tab);
    });

    $(this.element.nativeElement).off("click");
    $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
      event.preventDefault();
      const fragment = $(this).data('fragment');
      self.router.navigate([], { relativeTo: self.route, fragment });
    });
  }

  ngOnDestroy():void{
    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();
  }

  setActiveTab(tab) {
    this.currentTab = tab;
    if(this.currentTab === 'reminders'){
      this.showRemindersPage();
    }
  }
  
  openP2pDetailModal() {
    const data = {
      fundraisers: this.data,
      placeOfCall: 'search'
    }

    const modalRef = this.modalP2pDetailService.open(data);

    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pDetailService.modalRef = null;
    })
  }

  resetSearch() {
    this.itemSearch.setValue('');
  }

  getRaised(donors) {
    let raised = 0
    for (let i = 0; i < donors.length; i++) {
      raised += donors[i].raised;
    }
    return raised;
  }

  getProgressBarHtml () {
    if (this.goal === 0 || this.raised > this.goal) {
      var progressValue = 100
    } else {
      var progressValue = (this.raised/this.goal) * 100
    }
    var progressBarHtml = `<div role="progressbar" aria-valuenow="${progressValue}" aria-valuemin="0" aria-valuemax="100" 
    class="progress-bar active p2p-progress" style="width:${progressValue}%"></div>`

    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(progressBarHtml);
    return sanitizedHtml;
  }

  copyIframeLink(url) {
    this.clipboard.copy(url);
    this.toastService.show('success', 'URL copied to clipboard', {delay: 1500})
  }

  onClickAddBulkMilestones() {
    this.isModalOpen = true;

    const modalRef = this.modalP2pAddBulkMilestonesService.open({
      campaign: this.campaignDetail,
      placeOfCall: 'campaign-details'
    });
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddBulkMilestonesService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  onClickFulfillBulkPledges(){
    this.isModalOpen = true;
    const modalRef = this.modalP2pFulfillBulkPledgesService.open({
      campaign: this.campaignDetail,
      placeOfCall: 'campaign-details'
    });

    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pFulfillBulkPledgesService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  onClickCreate() {
    this.isModalOpen = true;

    const modalRef = this.modalP2pAddFundrasingService.open({
      orgId: this.orgId,
      campaign: this.campaignDetail
    });
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddFundrasingService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  onClickImport() {
    const action = DialogActions.openDialog({
      payload: {
        name: "importChampions",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          teams: this.teams,
          campaignId: this.p2pId,
          loadCampaignList: false,
        }
      }
    });
    this.store.dispatch(action);
  }

  onClickNotifyAll() {
    const type = "sendFundraisersProgressReminder";
    let params = {
      campaignId: this.p2pId,
    }


    const title = `Send reminder to all champions`
    const message = `Send fundraiser progress updates to all champions`
    window['orgMain'].showSendSimpleReminderModal(title, message, params, type)
  }

  onClickDownload() {
    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
    let hideLink = true
    window['orgMain'].setupQRDownload('p2p-leaderboard',this.campaignDetail.id, this.leaderboardUrl, handle + "_" + this.campaignDetail.name,null,hideLink)
  }

  onRefreshClick() {
    this.router.navigateByUrl(`/manage/p2p/${this.p2pId}`)
  }

  onClickDownloadQRCards(){
    this.peerToPeerManageService.getDownloadQRCards(this.p2pId).subscribe((data:any)=>{
      this.isModalOpen = true;
      const modalRef = this.modalP2pDowloadQRCardsService.open({fileName: data.fileName});
      modalRef.onClose.pipe().subscribe(() =>{
        this.modalP2pDowloadQRCardsService.modalRef = null;
        this.isModalOpen = false;
      })
    });
  }

  navigateByUrl(url: string) {
    return this.router.navigateByUrl(url);
  }

  showRemindersPage() {
    const { scheduler, SchedulerTaskType, $ }: any = window;
    scheduler.reset();

    scheduler.data = this.campaignDetail
    scheduler.campaignId = this.campaignDetail.id;

    scheduler.updateEventDateTime();

    const taskTypeList = [
      SchedulerTaskType.P2PUpdateToChampians
    ];

    let scheduledList = [];
    let completedList = [];
    let cancelledList = [];
    var sortRemindersByStatus = function(reminders) {
      for (let i = 0; i < reminders.length; i++) {
        if(reminders[i].status === 0) 
          scheduledList.push(reminders[i])
        if(reminders[i].status === 2 || reminders[i].status === 3)
          completedList.push(reminders[i])
        if(reminders[i].status === 4)
          cancelledList.push(reminders[i])
      }
    }

    return scheduler.getMultipleTaskListByCampaign(scheduler.data, taskTypeList).then(() => {
      const p2pReminders = scheduler.list.filter((reminder) => {
        const p2pWeekly = reminder.p2pWeekly || false;
        return p2pWeekly === false || (p2pWeekly === true && reminder.status !== 0);
      });

      const p2pWeeklyList = scheduler.list.filter(reminder => reminder.p2pWeekly === true && reminder.status === 0);

      sortRemindersByStatus(p2pReminders);

      if(p2pWeeklyList.length < 1) {
        $(`*[data-section="p2pWeeklyReminderCard"]`).hide();
      } else {
        $(`*[data-section="p2pWeeklyReminderCard"]`).show();
        const listHTML = scheduler.getScheduledTaskListHTML(p2pWeeklyList);
        $(`*[data-section="p2pWeeklyReminderListContainer"]`).html(listHTML);
      }

      if(scheduledList.length < 1) {
          $(`*[data-section="scheduledReminderCard"]`).hide();
      } else {
          $(`*[data-section="scheduledReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(scheduledList);
          $(`*[data-section="scheduledReminderListContainer"]`).html(listHTML);
      }

      if(completedList.length < 1) {
          $(`*[data-section="completedReminderCard"]`).hide();
      } else {
          $(`*[data-section="completedReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(completedList);
          $(`*[data-section="completedReminderListContainer"]`).html(listHTML);
      }

      if(cancelledList.length < 1) {
          $(`*[data-section="cancelledReminderCard"]`).hide();
      } else {
          $(`*[data-section="cancelledReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(cancelledList);
          $(`*[data-section="cancelledReminderListContainer"]`).html(listHTML);
      }
        
      return null;
    }).then(() => {
        const timestamp = scheduler.data.campaignTypeData.startDateTimeGmtUnix || 0;
        scheduler.timestamp[SchedulerTaskType.P2PUpdateToChampians] = timestamp;
 
        scheduler.updateReminders();
        return scheduler.init(() => {
            this.showRemindersPage();

            if($("#scheduledReminderHeadingLink").hasClass("collapsed")) {
              $("#scheduledReminderHeadingLink").click();
          }
        });
    })
  }

}
